// removed by extract-text-webpack-plugin
module.exports = {"CardBody":"Relation__CardBody__uzSh5","BadgeText":"Relation__BadgeText__1vNxx","QuestionMark":"Relation__QuestionMark__3b-Us","Question":"Relation__Question__iGSmI"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Profile/Relation/Relation.css
// module id = 584
// module chunks = 0